module.exports = __webpack_public_path__ + "img/Photo1.2.ffcb622a.png";